/* eslint-disable @next/next/no-img-element */
import { FunctionComponent } from 'react'

const GithubActivity: FunctionComponent = (): JSX.Element => {
  return (
    <div className="flex flex-col">
      <img
        src="https://raw.githubusercontent.com/AkashRajpurohit/AkashRajpurohit/master/assets/github-snake-dark.svg"
        alt="Snake game for AkashRajpurohit github activity"
      />
    </div>
  )
}

export default GithubActivity
